// Mock data for Harry and Jacobs Estate Agency

export const properties = [
  {
    id: 1,
    title: "Modern 3 Bedroom House",
    type: "sale",
    price: 650000,
    bedrooms: 3,
    bathrooms: 2,
    area: 1450,
    location: "Harrow on the Hill",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80",
    description: "Beautiful modern family home with spacious living areas and a private garden.",
    features: ["Garden", "Parking", "Modern Kitchen", "En-suite"]
  },
  {
    id: 2,
    title: "Luxury 2 Bed Apartment",
    type: "rent",
    price: 1850,
    bedrooms: 2,
    bathrooms: 2,
    area: 950,
    location: "Wealdstone",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80",
    description: "Contemporary apartment in prime location with excellent transport links.",
    features: ["Balcony", "Concierge", "Gym", "Underground Parking"]
  },
  {
    id: 3,
    title: "Victorian 4 Bedroom House",
    type: "sale",
    price: 825000,
    bedrooms: 4,
    bathrooms: 3,
    area: 2100,
    location: "Pinner",
    image: "https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=800&q=80",
    description: "Stunning Victorian property with period features and modern amenities.",
    features: ["Period Features", "Large Garden", "Off-street Parking", "Conservatory"]
  },
  {
    id: 4,
    title: "Modern Studio Apartment",
    type: "rent",
    price: 1100,
    bedrooms: 1,
    bathrooms: 1,
    area: 450,
    location: "Harrow Town Centre",
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80",
    description: "Perfect starter home or investment property in the heart of Harrow.",
    features: ["Open Plan", "Modern Fixtures", "Close to Station"]
  },
  {
    id: 5,
    title: "Family Home with Garden",
    type: "sale",
    price: 750000,
    bedrooms: 4,
    bathrooms: 2,
    area: 1800,
    location: "Stanmore",
    image: "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=800&q=80",
    description: "Spacious family home featuring large garden and driveway.",
    features: ["Large Garden", "Driveway", "Near Schools", "Updated Kitchen"]
  },
  {
    id: 6,
    title: "Contemporary 3 Bed Flat",
    type: "rent",
    price: 2200,
    bedrooms: 3,
    bathrooms: 2,
    area: 1200,
    location: "Kenton",
    image: "https://images.unsplash.com/photo-1502672260066-6bc35f0a1e1e?w=800&q=80",
    description: "Stylish apartment with modern finishes throughout.",
    features: ["Balcony", "Parking", "Modern Kitchen", "Storage"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "M Zarzour",
    text: "Unbelievable service from the team at Harry and Jacobs. My land and my property which have been in the market for almost 2 years had not been sold when giving it to local estate agents. When I met Asad, he promised me that he will sell these in no more than a month, he managed to sell them in a WEEK!! Again, Unbelievable, extraordinary and phenomenal service from the gents! Thank you and will Definitely recommend!",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Johnson",
    text: "Professional, efficient and always available. Harry and Jacobs helped us find our dream home in Harrow. Their knowledge of the local area is exceptional.",
    rating: 5
  },
  {
    id: 3,
    name: "David Patel",
    text: "As a landlord, I've worked with several agencies but none compare to Harry and Jacobs. They handle everything professionally and keep me informed at every step.",
    rating: 5
  },
  {
    id: 4,
    name: "Emma Williams",
    text: "Sold my property in just 10 days at the asking price! The team was brilliant throughout the entire process. Highly recommended!",
    rating: 5
  }
];

export const team = [
  {
    id: 1,
    name: "Asad Khan",
    position: "Director",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80",
    bio: "With over 15 years of experience in the property industry, Asad leads our team with expertise and dedication."
  },
  {
    id: 2,
    name: "James Mitchell",
    position: "Senior Sales Negotiator",
    image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80",
    bio: "James brings exceptional negotiation skills and market knowledge to every transaction."
  },
  {
    id: 3,
    name: "Sophie Turner",
    position: "Lettings Manager",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80",
    bio: "Sophie manages our lettings division with professionalism and attention to detail."
  }
];

export const services = [
  {
    id: 1,
    title: "Property Sales",
    description: "Expert guidance through every step of selling your property, achieving the best possible price.",
    icon: "Home",
    features: ["Free Valuation", "Professional Photography", "Marketing Strategy", "Negotiation Support"]
  },
  {
    id: 2,
    title: "Property Lettings",
    description: "Comprehensive letting services for landlords and tenants with full management options.",
    icon: "Key",
    features: ["Tenant Finding", "Referencing", "Inventory Services", "Rent Collection"]
  },
  {
    id: 3,
    title: "Property Management",
    description: "Full property management service taking care of all aspects of your rental property.",
    icon: "Building",
    features: ["Maintenance Coordination", "Tenant Relations", "Financial Reporting", "Legal Compliance"]
  },
  {
    id: 4,
    title: "Expert Valuations",
    description: "Accurate property valuations from experienced professionals who know the local market.",
    icon: "Calculator",
    features: ["Market Analysis", "Comparable Research", "Investment Advice", "Quick Turnaround"]
  }
];

export const stats = [
  {
    value: "97%",
    label: "Of Asking Price Achieved"
  },
  {
    value: "92%",
    label: "Tenant Renewal Rate"
  },
  {
    value: "500+",
    label: "Properties Sold"
  },
  {
    value: "15+",
    label: "Years Experience"
  }
];

export const contactInfo = {
  address: "25 Masons Avenue, Harrow HA3 5AH, UK",
  phone: "020 8189 8889",
  email: "info@harryandjacobs.com",
  hours: {
    weekdays: "9:00 AM - 6:00 PM",
    saturday: "10:00 AM - 4:00 PM",
    sunday: "Closed"
  }
};

export const charityInfo = {
  name: "H&J Charity",
  tagline: "You can rest easy in your faith, knowing that 100% of your contribution towards the charity will go directly to helping those who need it most",
  description: "At Harry & Jacobs, we believe in giving back to our community. Through H&J Charity, we support local families and individuals in need, ensuring every penny of your donation makes a real difference.",
  focus: [
    "Supporting homeless families in Harrow",
    "Providing emergency housing assistance",
    "Helping vulnerable individuals find stable accommodation",
    "Community outreach programs"
  ]
};
